<template>
  <div style="padding-top: -2px; margin-top: -2px">
    <div v-if="!multiple">
      <s-select-generic ref="sarea" autocomplete class="text" itemtext="GenDescription" itemvalue="GenID"
        :disabled="disabled" id="GenDescription" :value="value" :return-object="returnObject" @input="input($event)"
        :config="config" :label="label" :full="full || showAll" :autofocus="autofocus" :text="text" :clearable="clearable"
        :noDefault="noDefault || showAll" @change="change($event)">
      </s-select-generic>
    </div>
    <div v-if="multiple">
      <v-select multiple v-model="selected" :items="items" item-text="GenDescription" item-value="GenID"
        :return-object="returnObject" :label="label" :clearable="clearable">
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index < 1" x-small class="ma-1" color="orange" label outlined>
            {{ item.GenDescription }}
          </v-chip>
          <span v-else-if="index === 1" class="ml-2 grey--text text--darken-1">
            +{{ selected.length - 1 }}
          </span>
        </template>
      </v-select>

    </div>
  </div>

</template>

<script>
import _sGenericService from "./../../services/General/GenericService";
export default {
  name: "SelectArea",
  components: {},
  props: {
    autofocus: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: null,
    text: { type: String, default: "" },
    label: {
      type: String,
      default: "",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    centercost: {
      type: Boolean,
      default: false,
    },
    noDefault: {
      type: Boolean,
      default: false,
    },
    typeCost: {
      type: Number,
      default: 0,
    },
    onlyAccountCapex: {
      type: Number,
      default: 0,
    },
    typeArea: {
      type: Number,
      default: 3,
    },
    full: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    showAll: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    typeArea() {
      this.config.params.TypeArea = this.typeArea;
    },
    typeCost() {
      this.config.params.TypeCost = this.typeCost;
    },
    value(value) {
      this.item = value;
    },
    selected(newVal) {
      this.$emit('input', newVal); // Emitir los valores seleccionados al padre
    },
  },
  methods: {
    getSelectRef() {
      const selectRef = this.$refs.sarea;
      return Array.isArray(selectRef) ? selectRef[0] : selectRef;
    },
    change(elements) {
      if (this.centercost) {
        //console.log('elemeneeeee ', elements);
      }
    },

    focus() {
      this.$nextTick(() => {
        const select = this.getSelectRef();
        if (select?.focus) {
          select.focus();
        }
        if (select?.isFocused) {
          select.isFocused(true);
        }
      });
    },
    error(msg) {
      this.$nextTick(() => {
        const select = this.getSelectRef();
        if (select?.error) {
          select.error(msg);
          return;
        }
        if (select?.focus) {
          select.focus();
        }
      });
    },
    input(val) {
      this.$emit("input", val);
      console.log("input", val);

    },
  },
  data: () => ({
    item: 0,
    val: "",
    items: [],
    config: {},
    selected: [],
  }),

  created() {
    this.config = {
      url: _sGenericService.getUrlSearchArea(),
      title: this.label,
      params: {
        TypeArea: this.typeArea,
        search: "",
        requestID: this.$fun.getUserID(),
      },
    };
    if (this.centercost) {
      this.config.url = _sGenericService.getUrlSearchCenterCost();
      this.config.params = {
        search: "",
        TypeCost: this.typeCost,
        OnlyAccountCapex: this.onlyAccountCapex,
        requestID: this.$fun.getUserID(),
      };
    }
    this.$http
      .post(
        _sGenericService.getUrlSearchArea(),
        {},
        {
          params: {
            TypeArea: this.typeArea,
            search: "",
            requestID: this.$fun.getUserID(),
          },
        }
      )
      .then((r) => {
        if (r.status == 200) {
          this.items = r.data;
        }
      });
  },
};
</script>
